const PlayIconInTo = () => <span className="playIconInTo" />;

export default PlayIconInTo;
